import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { InternalAppraisalCdaStore } from '../stores/internalAppraisalCdaStore';

export const useInternalAppraisalStore = () => useContext<{
  internalAppraisalCdaStore: InternalAppraisalCdaStore
}>(StoreContext);